import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import CountUp from 'react-countup';
import Slider from "react-slick";
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet'; 

import treatment1 from '../Components/img/treament1.jpg';
import treatment2 from '../Components/img/treament2.jpg';
import treatment3 from '../Components/img/treament3.jpg';
import treatment4 from '../Components/img/treament4.jpg';
import treatment5 from '../Components/img/treament5.jpg';
import treatment6 from '../Components/img/treament6.jpg';
import treatment7 from '../Components/img/treament8.jpg';
import treatment8 from '../Components/img/treament9.jpg';
import treatment9 from '../Components/img/treament4.jpg';

const Treatment = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 3000,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

 
  const treatments = [
    {
      id: 1,
      image: treatment1,
      title: "Adult Psychiatric Cases",
      description: "Adult psychiatric cases include mental health disorders that affect people. These disorders can include depression, anxiety.",
      link: "/Adult_Psychaitric_Cases",
    },
    {
      id: 2,
      image: treatment2,
      title: "Psychotherapy and Counseling",
      description: "Psychotherapy and counseling are of talking therapies that aim to help individuals address  behavioral challenges.",
      link: "/Counselling",
    },
    {
      id: 3,
      image: treatment3,
      title: "IQ Testing and Aptitude Testing",
      description: "IQ Testing and Aptitude Testing are of assessments designed to measure different aspects of an individual’s cognitive abilities.",
      link: "/IQ_Testing",
    },
    {
      id: 4,
      image: treatment4,
      title: "Child Guidance",
      description: "Child Guidance refers to the process of helping children develop appropriate behaviors, emotional regulation, and social skills.",
      link: "/Child_Guidance",
    },
    {
      id: 5,
      image: treatment5,
      title: "Career Counseling",
      description: "Career Counseling is a process in which a trained professional helps individuals understand their strengths, to guide them in making career decisions.",
      link: "/Career_Counseling",
    },
    {
      id: 6,
      image: treatment6,
      title: "Psychometric Evaluation",
      description: "Psychometric Evaluation is the use of scientifically designed tests to assess an individual's cognitive abilities, mental health, skills, and motivations.",
      link: "/Psychometric_Evaluation",
    },
    {
      id: 7,
      image: treatment7,
      title: "Marital Therapy",
      description: "Marital therapy, also known as couples therapy, is a type of psychotherapy that helps couples address and resolve issues affecting their relationship.",
      link: "/Marital_Therapy",
    },
    {
      id: 8,
      image: treatment8,
      title: "Group Therapy",
      description: "Group therapy is a treatment where multiple patients are treated at once by a healthcare professional. It can be used to treat a variety of conditions, including anxiety.",
      link: "/Group_Therapy",
    },
    {
      id: 9,
      image: treatment9,
      title: "Behavioral Therapy",
      description: "Behavioral Therapy is a type of psychotherapy that focuses on modifying or changing harmful or maladaptive behaviors.",
      link: "Behavorial_Therapy",
    },
  ];

  // Counters Data
  const counters = [
    {
      counter: 1000,
      ext: "+",
      txt: "Happy Patients",
      icon: "fas fa-smile",
    },
    {
      counter: 500,
      ext: "+",
      txt: "Successful Therapy",
      icon: "fas fa-check-circle",
    },
    {
      counter: 2,
      ext: "+",
      txt: "Years of Experience",
      icon: "fas fa-calendar",
    },
    {
      counter: 5,
      ext: "+",
      txt: "Team members",
      icon: "fas fa-users",
    },
  ];

  return (
    <>
       <Helmet>
        <title>Treatments - Dr. Swati Chavhan Vanjari</title>
        <meta name="google-site-verification" content="hDy2TyO5-XOsY-kqHa_AsfhwAKrzVrvGjXLKbQkdVlw" />
        <meta name="description" content="Explore the various treatments and therapies offered by Dr. Swati Chavhan Vanjari including psychiatric care, psychotherapy, career counseling, and more." />
        <meta name="keywords" content="treatments, therapies, adult psychiatric cases, psychotherapy, career counseling, IQ testing, marital therapy, mental health" />
      </Helmet>
      <div className="py-5 bg-light">
        <Container>
          <Row>
            <div className="col-lg-12 text-center mb-4">
              <h2 className="text-dark">Treatments</h2>
              <p className="text-muted">Our Services</p>
            </div>
         <Slider {...settings}>
  {treatments.map(treatment => (
    <div key={treatment.id} className="col-lg-4 mb-5 px-3 col-md-12">
      <Link to={treatment.link} className="text-decoration-none">
        <div className="card shadow border-0 p-4">
          <img src={treatment.image} alt={treatment.title} className="img-fluid rounded-circle mb-4" />
          <h5 className="" style={{color:'#093c60'}}>{treatment.title}</h5>
          <p className="text-muted">{treatment.description}</p>
        </div>
      </Link>
    </div>
  ))}
</Slider>

          </Row>
        </Container>
      </div>

      <section className="py-5">
        <Container>
          <Row>
            {counters.map((item, index) => (
              <Col key={index} lg={3} md={6} className="mb-4">
                <div className="card shadow border-0 p-4 text-center">
                  <i className={`${item.icon} fa-3x  mb-3`} style={{color:'#13baab'}}></i>
                  <h2 style={{color:'#093c60'}}>
                    <CountUp end={item.counter} duration={5} />{item.ext}
                  </h2>
                  <p className="text-muted">{item.txt}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Treatment;
